import { atom } from 'jotai'

const state = atom<boolean>(false)
export const showRangeCalendarStore = { state } as const
